import React from 'react';
import { useTranslation } from 'react-i18next';
import ThumbWithLoader from '../../../Sidebar/_partials/ThumbWithLoader';
import s from './LoveSuggestionPanel.scss';
export var LoveSuggestionPanel = function (_a) {
    var hasSuggestions = _a.hasSuggestions, deviations = _a.deviations, isLoading = _a.isLoading, type = _a.type;
    var t = useTranslation().t;
    if (!hasSuggestions) {
        return null;
    }
    var slice = deviations.length
        ? deviations
        : Array(6).fill(undefined);
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t("sidebar.blockTitle." + type)),
        React.createElement("div", { className: s['slider'] }, slice.map(function (deviation) { return (React.createElement(ThumbWithLoader, { key: deviation.deviationId, deviation: deviation, isLoading: isLoading, width: 137, height: 100, className: s['thumb'] })); }))));
};
LoveSuggestionPanel.displayName = 'LoveSuggestionPanel';
export default LoveSuggestionPanel;
//# sourceMappingURL=LoveSuggestionPanel.js.map